import { List } from "immutable";
import * as M from "../models";

export interface AdminPageListState {
    loading: boolean;
    pages: List<M.AdminPage.ListItem>;
}

export const initialState: AdminPageListState = {
    loading: true,
    pages: List(),
};



// WEBPACK FOOTER //
// ./src/store/AdminPageListState.ts